module.exports = __webpack_public_path__ + "img/icon_e34.e55aed99.png";